<ng-container *transloco="let t; read: 'partials.agenda'">
  <ng-container *ngIf="ac">
    <h2 class="label">
      {{ t('agenda') }}
      <div class="timezone-switcher" *ngIf="timezone.showTimezoneSwitch()">
        <div class="p-grid">
          <div class="p-col text"><span>{{ t('labels.local_time') }}</span></div>
          <div class="p-col-fixed"><p-inputSwitch [(ngModel)]="showProcedureTimes" (onChange)="onChangeShowProcedureTimes($event)"></p-inputSwitch></div>
        </div>
      </div>
    </h2>
    <div class="agenda" [class.show-timezone-times]="timezone.showTimezoneSwitch() === true && showProcedureTimes === true">
      <ng-container *ngFor="let container of containers" [ngSwitch]="container.type">
        <app-agenda-block-exercise *ngSwitchCase="'exercise'" [container]="container"></app-agenda-block-exercise>
        <app-agenda-block-org *ngSwitchCase="'org'" [container]="container"></app-agenda-block-org>
        <app-agenda-block-break *ngSwitchCase="'break'" [container]="container"></app-agenda-block-break>
        <app-agenda-block-conference *ngSwitchCase="'conference'" [container]="container"></app-agenda-block-conference>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
